(function () {

  // add css via js
  if (!document.querySelector('#bundle-text-animation')) {
    const style = document.createElement('style');
    style.id = 'bundle-text-animation';
    style.innerHTML = `
      .no-product,
      .product-text{
        display:inline-block;
      }

      .text-in{
        animation:textIn .4s ease forwards;
      }

      .text-out{
        animation:textOut .4s ease forwards;
      }

      @keyframes textIn{
        from{
          opacity:0;
          transform:translateY(20px);
        }
        to{
          opacity:1;
          transform:translateY(0);
        }
      }

      @keyframes textOut{
        from{
          opacity:1;
          transform:translateY(0);
        }
        to{
          opacity:0;
          transform:translateY(-20px);
        }
      }
    `;
    document.head.appendChild(style);
  }

  function animateText() {
    const titles = document.querySelectorAll('.bundle-counter .no-product, .bundle-counter .product-text');
    if (!titles.length) return;

    titles.forEach(el => {
      el.classList.remove('text-in','text-out');

      // force reflow so animation repeats
      void el.offsetWidth;

      el.classList.add('text-in');

      setTimeout(() => {
        el.classList.add('text-out');
      }, 2800);
    });
  }

  window.onload = animateText;

  // repeat every 3 sec
  setInterval(animateText, 3000);

})();
